export enum TipoError {
  ERROR,
  NOINFO,
}
